import { Injectable, inject } from '@angular/core';

import { AiInsightsService } from 'app/providers/semantria-api/ai-insights.service';
import { SystemService } from 'app/services/system.service';

@Injectable({
  providedIn: 'root',
})
export class InsightImageLoaderService {
  private readonly aiInsightsService = inject(AiInsightsService);
  private readonly systemService = inject(SystemService);

  async load(insightId: string, imageId?: string): Promise<string | ArrayBuffer | undefined> {
    let resolvedImageId = imageId;
    if (!resolvedImageId) {
      const images = await this.aiInsightsService.getImages(insightId);
      resolvedImageId = images?.[0]?.image_id;
    }

    if (!resolvedImageId) {
      return undefined;
    }

    const blob = await this.aiInsightsService.downloadImage(insightId, resolvedImageId);
    return this.systemService.readBlob(blob);
  }
}
